export const defaultOrderBy = 'CreatedDateTimeDesc';

// TODO: Remove the nonsortable properties when ready to support
export const baseColumnsDefaultConfigs = [
  { id: 'rma-number', width: 150 },
  { id: 'shipment-number', width: 150 },
  { id: 'order-number', width: 150 },
  { id: 'created-date', width: 125 },
  { id: 'received-date', width: 150 },
  { id: 'returning-party', width: 150, nonsortable: true },
  { id: 'ship-to', width: 120, nonsortable: true }, // mirrors shipping grid shipFrom
  { id: 'tracking-number', width: 150, nonsortable: true },
  { id: 'service', width: 150, nonsortable: true },
  { id: 'insuranceFee', width: 130 },
  { id: 'label-printed', width: 130 },
  { id: 'customer-email', width: 150, nonsortable: true },
  { id: 'return-note', width: 150, nonsortable: true },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: !!column.pinned,
}));

const otherColumnsDefaultConfigs = [
  { id: 'provider', width: 92 },
  { id: 'package', width: 110, nonsortable: true },
  { id: 'state', width: 70, nonsortable: true },
  { id: 'insurance', width: 102 },
  { id: 'country', width: 90 },
  { id: 'confirmation', width: 122, nonsortable: true },
  { id: 'city', width: 150, nonsortable: true },
  { id: 'rate', width: 100 },
  { id: 'carrier', width: 150, nonsortable: true },
  { id: 'store', width: 150, nonsortable: true },
  { id: 'source', width: 150, nonsortable: true },
].map((column) => ({
  ...column,
  minWidth: 70,
}));

export const defaultColumnConfigurations = [...baseColumnsDefaultConfigs, ...otherColumnsDefaultConfigs];
